export default "/images/99bc75268992c5b811a64d0cf224c0ca.avif";